import { LogLevel } from "@azure/msal-browser";
import { b2cPolicies } from "@/b2cPolicies";

function getLoginRedirectUri() {
  const redirectPath = "/v/login/complete";
  const protocol = window.location.protocol;
  return protocol + "//" + window.location.host + redirectPath;
}

export function getLogoutRedirectUri() {
  const protocol = window.location.protocol;
  let host = window.location.host;

  // Check if we're on an environment-specific admin subdomain
  if (host.startsWith("admin")) {
    // Replace 'admin' or 'admin{env}' with '{env}' or nothing
    host = host.replace(/^admin\./, "").replace(/^admin([^.]+)\./, "$1.");
  }

  return protocol + "//" + host;
}

export const msalConfig = {
  auth: {
    clientId: b2cPolicies.clientId,
    authority: b2cPolicies.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: getLoginRedirectUri(),
    postLogoutRedirectUri: getLogoutRedirectUri(),
    navigateToLoginRequestUrl: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Too many logs in console, comment out return if needed
        return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};
